import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#ff5a00',
  width = '100%',
  className = '',
  viewBox = '0 0 22.6 22.6',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="globe-americas"
      d="M11.3,8A11.3,11.3,0,1,0,22.6,19.3,11.3,11.3,0,0,0,11.3,8Zm9.829,11.548-1.951-.488a.364.364,0,0,1-.216-.152l-.819-1.229a.367.367,0,0,1,0-.4l.893-1.339a.356.356,0,0,1,.139-.123l1.092-.546a9.762,9.762,0,0,1,.875,4.033C21.142,19.384,21.131,19.465,21.129,19.548ZM1.458,19.3A9.8,9.8,0,0,1,1.6,17.708c.326.483.662.978.907,1.338a6.054,6.054,0,0,0,.974,1.109,7.242,7.242,0,0,0,1.6,1.1c.629.318,1.552.818,2.2,1.177a.73.73,0,0,1,.373.637v1.459A2.174,2.174,0,0,0,8.3,26.075a2.76,2.76,0,0,1,.817,1.82v.994A9.853,9.853,0,0,1,1.458,19.3Zm9.109,9.8,0-1.114a4.081,4.081,0,0,0-1.238-2.948.737.737,0,0,1-.214-.515V23.069a2.184,2.184,0,0,0-1.126-1.912c-.661-.366-1.6-.878-2.248-1.2a5.909,5.909,0,0,1-1.319-.914,4.573,4.573,0,0,1-.709-.815c-.44-.647-1.164-1.719-1.613-2.385a9.867,9.867,0,0,1,7.27-6.19l2.36,2.36-.685.685A1.1,1.1,0,0,0,11,14.2h-.261a1.09,1.09,0,0,0-.762.31l-.452.439a1.086,1.086,0,0,0-.216,1.274l.182.364a1.459,1.459,0,0,0-1-.03l-1.421.473A1.273,1.273,0,0,0,6.9,19.373l.505.253a3.841,3.841,0,0,0,1.577.4,4.945,4.945,0,0,1,.4.5,2.728,2.728,0,0,0,.866.887l.154.077h3.214a.73.73,0,0,1,.515.214l.624.624a.668.668,0,0,1,.194.468,1.4,1.4,0,0,1-.413.987l-.517.516a1.819,1.819,0,0,0-.467.815l-.051.2a4.824,4.824,0,0,1-.145.5L12.132,29.1c-.275.023-.551.042-.832.042C11.052,29.142,10.81,29.122,10.567,29.1Zm3.227-.3.923-2.488a5.941,5.941,0,0,0,.194-.654l.047-.185c.015-.06.048-.116.186-.254l.419-.417a2.865,2.865,0,0,0,.84-2.019,2.135,2.135,0,0,0-.621-1.5l-.624-.624a2.2,2.2,0,0,0-1.546-.641H10.836c-.087-.1-.2-.255-.281-.367-.374-.511-.8-1.09-1.442-1.09a2.37,2.37,0,0,1-1.055-.249l-.107-.053,1-.333.423.367a1.1,1.1,0,0,0,.716.268h.258a1.094,1.094,0,0,0,.978-1.582l-.591-1.182.154-.151h.262a1.087,1.087,0,0,0,.773-.32l.365-.365a1.1,1.1,0,0,0,.043-1.5l.429-.429a1.456,1.456,0,0,0,0-2.061L11.241,9.462c.02,0,.04,0,.06,0a9.835,9.835,0,0,1,8.271,4.527l-1.047.524a1.821,1.821,0,0,0-.7.619l-.893,1.339a1.816,1.816,0,0,0,0,2.022l.819,1.229a1.822,1.822,0,0,0,1.075.757l2.159.539a9.86,9.86,0,0,1-7.189,7.8Z"
      transform="translate(0 -8)"
      fill={fill}
    />
  </svg>
);

export default SVG;
